import { render } from "./HowBuy.vue?vue&type=template&id=199e913d"
import script from "./HowBuy.vue?vue&type=script&lang=js"
export * from "./HowBuy.vue?vue&type=script&lang=js"

import "./HowBuy.vue?vue&type=style&index=0&id=199e913d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__